/**
 * @generated SignedSource<<2314afbcde7d8980ae1e76ca96f70867>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type keyboardShortcuts_issueNavigator$data = {
  readonly issueTypeField: {
    readonly issueType: {
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "keyboardShortcuts_issueNavigator";
};
export type keyboardShortcuts_issueNavigator$key = {
  readonly " $data"?: keyboardShortcuts_issueNavigator$data;
  readonly " $fragmentSpreads": FragmentRefs<"keyboardShortcuts_issueNavigator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "keyboardShortcuts_issueNavigator",
  "selections": [
    {
      "concreteType": "JiraIssueTypeField",
      "kind": "LinkedField",
      "name": "issueTypeField",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "name"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "b6db91587551c3c9c628860986b56a99";

export default node;
